import React, { Component } from 'react'

export default class Splash extends Component {

    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            this.ref.current.classList.add('fade');
        }, 500);
    }

    render() {
        return (
            <div ref={this.ref} id="splash" >
                <div className="image" style={{ backgroundImage: `url(/splash.png)` }} />
            </div>
        )
    }
}
